import React,{Component} from 'react'
import { Upload, message, Button, Icon ,Modal} from 'antd';
import {baseUrl, fileThumb, reqFileList} from '../../api'
import './upload-mobile.less'
import Helmet from "react-helmet";
import Logo from '../../assets/images/mobile-logo.png'
import ajax from "../../api/ajax";
import SockJS  from 'sockjs-client';
import Stomp from 'stompjs';
import {isImageUrl} from "antd/lib/upload/utils"
import authorizePage from "../../components/authorize/authorizePage";
import authorize from "../../components/authorize/authorize";
import queryString from "query-string";
let count=0;
const maxCount=9;

let timer1 = undefined;
class MobileUpload extends Component {
    state={
        orderId:'',
        disabled:false,
        fileList:[],
        removeable:true,
        downloadable:true,
        objectType:"",
    }


    exitHandle= ()=>{
        Modal.info({
            title: '上传功能已关闭，请扫码后再次上传！',
            maskClosable:false,
            mask:true,
            centered:true,
            okButtonProps:{
                hidden:true
            }
        });
        this.setState({
            disabled:true,
        })
        clearInterval(timer1);
    }
    checkLive=()=>{
        let result = ajax(baseUrl+'/cors/sesstionid');
        result.then((value) =>{
            if(value.code===200) {
                return true;
            }else if(value.code===401){
                this.exitHandle()
            }
        }, function(error) {
        });
    }
    handleBeforeUpload = (file, fileList) => {
        return new Promise((resolve, reject) => {
            count++
            if(count >maxCount) {
                if(count == fileList.length) {
                    message.error("最多同时上传"+maxCount+"张！")
                    count =0;
                }
                reject(file);
            }else if(file.size > 10000000){
                message.info("只能上传10M内文件");
                reject(file);
            }else {
                resolve(file);
            }
        });
    }
    handleRemove= info =>{
        if(!this.state.removeable){
            message.error("您没有权限删除！")
            return false
        }
        let result = ajax(baseUrl+'/api/v1/p/file/mobile/file',{"fileId":info.id,"orderId":this.state.orderId,"objectType":this.state.objectType},'DELETE');
        result.then((value) => {
            if(value.code===200) {
                return true;
            }else if(value.code===401){
                this.exitHandle()
            }else{
                message.error(value.message)
            }
        }, function(error) {
            message.error(error)
        });

    };
    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                if (file.response.code === 200) {
                    file.thumbUrl = this.getThumbUrl(file.response.data.fileName)
                    file.url = baseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                }else if(file.response.code===401){
                    file.status = 'error'
                    file.response = file.response.message;
                    this.setState({
                        disabled:true,
                    })
                    this.exitHandle()
                } else {
                    file.status = 'error';
                    if(file.response.message) {
                        file.response = file.response.message;
                        message.error(file.response)
                    }

                }
            }
            return file;
        });

        this.setState({fileList});
    };
    getThumbUrl=(fileName)=>{
        let thumbUrl = ""
        if(fileName.toLowerCase().endsWith(".docx") ||fileName.toLowerCase().endsWith(".doc") ){
            thumbUrl= fileThumb.word
        }else if(fileName.toLowerCase().endsWith(".xlsx") ||fileName.toLowerCase().endsWith(".xls") ){
            thumbUrl= fileThumb.excel
        }else if(fileName.toLowerCase().endsWith(".pdf") ){
            thumbUrl= fileThumb.pdf
        }
        return thumbUrl
    }
    getBase64  = (file) =>{
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    handlePreview = async file => {
        if(!this.state.downloadable){
            message.error("您没有权限查看和下载！")
            return false
        }
        let fileList = this.state.fileList
        let index = fileList.findIndex((value, index, obj) => {
            if(value.id && file.id){
                return value.id == file.id
            }else if(value.url && file.url){
                return value.url == file.url
            }
            return false
        })
        let pre = index-1;
        if(pre<0){
            pre = fileList.length-1;
        }
        let next = index+1;
        if(next>fileList.length-1){
            next = 0
        }
        while(!isImageUrl({url:fileList[pre].url})){
            pre = pre-1;
            if(pre<0){
                pre = fileList.length-1;
            }
        }
        while(!isImageUrl({url:fileList[next].url})){
            next = next+1;
            if(next>fileList.length-1){
                next = 0
            }
        }
        this.setState({
            previewPreFile: fileList[pre],
            previewNextFile: fileList[next]
        })
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        if(!isImageUrl({url:file.url})){
            window.open(file.url);
        }else {
            this.setState({
                previewImage: file.url || file.preview,
                previewVisible: true,
                inout:true,
            });
        }
    };
    handleCancel = () => this.setState({ previewVisible: false });
    getFileList = async (po) => {
        po.pageNum = 1;
        po.pageSize = 100;
        let result = await reqFileList(po)
        if(result.code===200) {
            const fileList = result.data.rows;
            let showFiles = [];
            fileList.forEach((item, index) => {
                item.uid = index;
                item.name = item.fileName;
                item.thumbUrl = this.getThumbUrl(item.fileName)
                item.url = baseUrl + '/' + item.filePath;
                showFiles.push(item);
            });
            this.setState({
                fileList:showFiles
            })
        }else if(result.code===401){
            this.exitHandle()
            //
        }
    }
    initSockJs=()=>{
        const socket  = new SockJS(baseUrl+"/ws")
        const stompClient = Stomp.over(socket);
        stompClient.connect({},  (frame)=> {
            stompClient.subscribe('/user/topic/notice/logout', frame => {
                let result = JSON.parse(frame.body)
                if (result.code == 200) {
                    let result = ajax(baseUrl+'/cors/logout');
                    result.then((value) => {
                        if(value.code===200) {
                            this.exitHandle()
                        }else if(result.code===401){
                            this.exitHandle()
                        }else{

                        }
                    }, function(error) {

                    });
                }
            });
        });
    }
    componentWillMount () {
        authorize("order_edit:file_delete").then(()=>{
            this.setState({
                removeable:true
            })
        }).catch(()=>{
            this.setState({
                removeable:false
            })
        })
        authorize("order_edit:file_download").then(()=>{
            this.setState({
                downloadable:true
            })
        }).catch(()=>{
            this.setState({
                downloadable:false
            })
        })
        if(this.props.match.params) {
            const orderId = this.props.match.params.orderId
            this.setState({
                orderId
            })
            let query = queryString.parse(this.props.location.search)
            if(query && query.objectType){
                this.setState({
                    objectType:query.objectType
                },()=>{
                    this.getFileList({orderId: orderId,objectType:this.state.objectType})
                    this.initSockJs()
                })
            }else{
                this.getFileList({orderId: orderId})
                this.initSockJs()
            }

            timer1 = setInterval(() => this.checkLive(), 30000);
        }
    }
    render () {
        const orderId = this.state.orderId;
        const props = {
            name: 'file',
            action: baseUrl + '/api/v1/p/file/mobile/file?objectType='+this.state.objectType+'&orderId='+orderId,
            onChange: this.handleChange,
            onRemove: this.handleRemove,
            onPreview:this.handlePreview,
            beforeUpload:this.handleBeforeUpload,
            multiple: true,
            accept:"image/*,doc,docx,xls,xlsx,pdf",
            disabled: this.state.disabled,
            listType:"picture-card",
            withCredentials: true,
        };
        const ct =(control)=>{
            if(control){
                let maxHeight = window.innerHeight;
                let maxWidth = window.innerWidth;
                console.log(maxWidth,maxHeight)
                if(maxWidth>500) {
                    if (maxHeight > maxWidth) {
                        maxHeight = maxHeight * 0.9
                    } else {
                        maxWidth = maxWidth * 0.9
                    }
                }

                const ratio = Math.min(maxWidth / control.naturalWidth, maxHeight / control.naturalHeight);
                const w=control.naturalWidth*ratio
                if(this.state.previewWidth!=w){
                    this.setState({
                        previewWidth:control.naturalWidth*ratio
                    })
                }
            }
        }
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='mobile-upload-title'>
                    上传附件
                </div>
                <div className='mobile-upload-content'>
                    <Upload {...props} fileList={this.state.fileList} capture="camera">
                        <div>
                            <Icon authority="order_import"  type="plus" />
                        </div>
                    </Upload>
                    <Modal className="preview-image" centered visible={this.state.previewVisible} width={this.state.previewWidth} footer={null} onCancel={this.handleCancel} closable={false}>
                        <div className="ctrl">
                            <Icon type="zoom-in" className="icon" onClick={() => {
                                window.open(this.state.previewImage)
                            }}/>
                            <Icon type="close" className="icon" onClick={this.handleCancel}/>
                        </div>
                        <div className="ctrl-left">
                            <Icon type="left" className="icon left" onClick={() => {
                                this.setState({
                                    inout:false
                                })
                                setTimeout(()=>{this.handlePreview(this.state.previewPreFile)},150)
                            }}/>
                        </div>
                        <div className="ctrl-right">
                            <Icon type="right" className="icon right"  onClick={() => {
                                this.setState({
                                    inout:false
                                })
                                setTimeout(()=>{this.handlePreview(this.state.previewNextFile)},150)
                            }}/>
                        </div>
                        <img alt="" ref={ct} className={this.state.inout?'fadeIn':'fadeOut'}  style={{ width: '100%' }} src={this.state.previewImage} />
                    </Modal>
                </div>
            </div>

        );
    }
}
export default authorizePage("order_edit:file_phoneupload")(MobileUpload)